<template>
  <div class="container">
    <div class="plan-price-sec">
     <div class="plan-price-sec-hd">
        <h1>Payment</h1>
        <p v-if="companyMemberships">
                <span v-if="companyMemberships.payment_plan=='trial'">{{(companyMemberships.membership)?companyMemberships.membership.name:''}} Plan - Free Trial</span>
                <span v-else>{{(companyMemberships.membership)?companyMemberships.membership.name:''}} Plan</span>
        </p>
        <p v-if="companyMemberships.payment_plan=='trial'">Two months trial <b> (no payment will be deducted now)</b> you can choose not to pay with two months.</p>
      </div>
      <div class="row mb-10">
        <div class="col-6">
          <div class="row">

            <div class="col-lg-4">
              <label >Card Holder Name <span class="text-danger">*</span></label>
              <div class="form-group">
                <input type="text"  v-model="paymentForm.card_holder_name" class="form-control" >
              </div>
            </div>
            <div class="col-lg-4">
              <label >Credit/Debit Card Number <span class="text-danger">*</span></label>
              <div class="form-group">
                <input type="text"  v-model="paymentForm.card_no" class="form-control" >
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label >Card Expiry Date <span class="text-danger">*</span></label>
                <input type="month"  v-model="paymentForm.expiry_date" class="form-control">

              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label >CVC <span class="text-danger">*</span></label>
                <input type="text"  v-model="paymentForm.card_cvc" class="form-control">

              </div>
            </div>
            <div class="col-lg-12 text-right mb-10">
              <router-link  class="btn btn--default" :to="{ name: 'upgrade-plan' }" type="button">Back</router-link>
<!--              <button @click="saveCard('trial')" class="btn btn-info" type="button" v-if="companyMemberships.payment_plan=='trial'">Save</button>-->
              <button @click="saveCard('next')" class="btn btn-info" type="button" >Next</button>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import router from "../../router/router";
export default {
  data() {
    return {
      companyMemberships: {},
      paymentForm: {},
      company_id: this.$store.getters.getSelectedCompany.id,
    };
  },
  serverPrefetch() {},
  created() {
    this.getCompanyMembership();
  },
  mounted() {},
  methods: {
    //---------- upgrade Fun--------------
    saveCard(type) {
        this.$axios
          .post(
            this.$PaymentMethod,
            {
              company_id: this.company_id,
              membership_id: this.companyMemberships.membership.id,
              card_holder_name: this.paymentForm.card_holder_name,
              card_no: this.paymentForm.card_no,
              month: this.paymentForm.expiry_date.split('-')[1],
              year: this.paymentForm.expiry_date.split('-')[0],
              cvc: this.paymentForm.card_cvc,
              method_type: 'stripe',
            },
            { headers: this.getAuthHeader() }
          )
          .then((res) => {
            if (res.data.status == 200) {
                this.$router.push({name: 'checkout'});
            }
          });
    },
    getCompanyMembership() {
      let params = {
        company_id: this.company_id,
      };
      this.$axios
        .get(this.$CompanyMembership, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.companyMemberships = response.data.result || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    currencyAmountFormat(value) {
      return this.currencyFormatter(value).toString().split(".")[0];
    }
  },
};
</script>


<style scoped>
.pkg-types .pkg{
  position: relative;
}
.free-pkg-tril{
  position: absolute;
  left: 0;
  bottom: 5px;
  width: 100%;
  text-align: center;
}
</style>
